"use client";

import { useEffect } from "react";
import { ensureVisitorSessionId } from "@/utils/visitorSessionId";

export default function VisitorSessionInitializer() {
  useEffect(() => {
    ensureVisitorSessionId();
  }, []);

  return null;
}
